import {BASE_URL} from "../../config/network";

// Availability of a vehicle and its equivalent vehicles on the location, see kav4go docs/p2p-location-availability.md.
const getLocationAvailabilityAPI = async ({locationId, vehicleId, startDate, endDate}) => {
    const query = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
        vehicle_id: String(vehicleId),
    });

    const URL = `${BASE_URL}/public/p2p/location/${locationId}/availability?${query.toString()}`;
    const METHOD = "GET";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    return await response.json();
};

export {getLocationAvailabilityAPI};
